import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearCopiedData,
  clearSelectedDataKey,
  setCopiedData,
  setIsToggled,
} from "redux/formDisplay";
import "./index.scss";
import { setResponseObject, setAutofilled } from "redux/uploadDocumentReducer";
import { Form } from "react-bootstrap";

const ToggleCopy = (props) => {
  const {
    label,
    name,
    togglesublabel,
    setSelectedData,
    selectedData,
    formErr,
    setFormErr,
    clearFieldError,
    autofill,
    togglegroup,
    isEditable,
    is_disabled,
    size
  } = props;
  const [isToggle, setIsToggle] = useState(false);
  const dispatch = useDispatch();

  const onToggle = () => {
    let toggle = isToggle;
    setIsToggle(!isToggle);
    dispatch(setAutofilled(!isToggle));
    dispatch(setIsToggled(!isToggle));

    if (!toggle) {
      autofill?.map((item) => {
        if (formErr[item.destination_field]) {
          delete (formErr[item.destination_field])
          clearFieldError && clearFieldError(item.destination_field)
        }
        dispatch(
          setSelectedData({
            key: [item.destination_field],
            value: selectedData[item.source_field],
          })
        );
        dispatch(setSelectedData({ key: name, value: !toggle }));
        dispatch(
          setCopiedData({
            key: [item.destination_field],
            value: selectedData[item.source_field],
          })
        );
      });
      if(togglegroup)
      togglegroup?.forEach((item) => {
          dispatch(setSelectedData({ key: item,value:false}));
        })
      setFormErr && setFormErr(formErr)
    } else {
      dispatch(setSelectedData({ key: name, value: !toggle }));
      dispatch(clearCopiedData());
    }
  };

  useEffect(() => {
    if (isToggle) {
      autofill?.map((item) => {
        dispatch(
          setSelectedData({
            key: [item.destination_field],
            value: selectedData[item.source_field],
          })
        );
        dispatch(setSelectedData({ key: name, value: isToggle }));
        dispatch(
          setCopiedData({
            key: [item.destination_field],
            value: selectedData[item.source_field],
          })
        );
      });
    } else {
      dispatch(setSelectedData({ key: name, value: isToggle }));
      dispatch(clearCopiedData());
    }
  }, [isToggle]);

  useEffect(() => {
    if (name)
      dispatch(setSelectedData({ key: name, value: selectedData[name] }));
    if (selectedData[name]) {
      setIsToggle(true);
      autofill?.map((item) => {
        dispatch(
          setSelectedData({
            key: [item.destination_field],
            value: selectedData[item.source_field],
          })
        );
        dispatch(setSelectedData({ key: name, value: isToggle }));
        dispatch(
          setCopiedData({
            key: [item.destination_field],
            value: selectedData[item.source_field],
          })
        );
      });
    } else {
      setIsToggle(false);
      dispatch(setSelectedData({ key: name, value: isToggle }));
      dispatch(clearCopiedData());
    }
  }, [name]);

  return (
    <div className={`toggle_copy ${size}`}>
      <label className="toggle_copy_label">{label}</label>
      <div className="toggle_copy_switch">
        <label className="toggle_switch_label" htmlFor={name}>
          <input
            className={`toggle_switch_input`}
            name={name}
            type="checkbox"
            id={name}
            value={isToggle}
            onChange={onToggle}
            disabled={is_disabled ? is_disabled : isEditable ? false:true}
          />
          <div
            className={`${
              selectedData[name] ? "switchChecked" : "switchUnchecked"
            }`}
          ></div>
        </label>
      </div>
    </div>
  );
};

export default ToggleCopy;
